<template>
    <v-row
        no-gutters
        class="fill-height gradient-blue pb-8"
        :style="showSignupBg ? `background: url(${baseUrl+ '/static/img/signup-dashboard.png' }); background-size: cover` : ''"
    >
        <v-col class="px-0">
            <v-row class="flex-column align-center justify-center" no-gutters>
                <slot></slot>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { computed } from "@vue/composition-api";
import AppModule from "../../store/modules/app";

export default {
    name: "FormContainerGrey",
    setup(props, ctx) {
        const { baseUrl } = AppModule();
        const showSignupBg = computed(() => ctx.root._route.name === 'signup');

        return {
            showSignupBg,
            baseUrl
        }
    }
};
</script>
